import {StateEnum} from 'core/enum';

export const NAME = StateEnum.coreRouter;
